define([
    "./remoteMessageModule",
    "./remoteMessageModal"
], function () {
});